import listActions from 'src/modules/foodOperator/list/foodOperatorListActions';
import FoodOperatorService from 'src/modules/foodOperator/foodOperatorService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import Message from 'src/view/shared/message';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'FOODOPERATOR_DESTROY';

const foodOperatorDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: foodOperatorDestroyActions.DESTROY_STARTED,
      });

      await FoodOperatorService.destroyAll([id]);

      dispatch({
        type: foodOperatorDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(i18n('entities.foodOperator.destroy.success'));

      dispatch(listActions.doFetchCurrentFilter());

      navigateTo('/library/food-operator');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: foodOperatorDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: foodOperatorDestroyActions.DESTROY_ALL_STARTED,
      });

      await FoodOperatorService.destroyAll(ids);

      dispatch({
        type: foodOperatorDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(i18n('entities.foodOperator.destroyAll.success'));

      navigateTo('/library/food-operator');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: foodOperatorDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default foodOperatorDestroyActions;
